import React from 'react';
import Attributes from '../../../components/Attributes';
import Button from '../../../components/Button';
import useModal from '../../../hooks/useModal';
import useAsync from '../../../hooks/useAsync';
import { getContacts } from '../../../api/contacts';
import SelectContacts from '../../../components/SelectContacts';
import { getUserFullName } from '../../../components/helpers/functions';
import { AvatarGenerated } from '../../../components/Avatar';
import { PlusCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';

const getTitle = ({ type, title, company, location }) => {
	if (type === 'person') {
		if (company && title) {
			return `${title} at ${company.companyName}`;
		} else if (company && !title) {
			return `from ${company.companyName}`;
		} else if (!company && title) {
			return title;
		}
	} else if (type === 'company') {
		if (location) {
			return `${location && ` from ${location}`}`;
		}
		return null;
	}
	return null;
};
const ASSET_MODULE_ID = process.env.REACT_APP_MODULE_ID_ASSETS;

const VendorsStepAsset = ({
	moduleFieldsBreakdown,
	skipModuleKeys,
	updatedForm,
	setUpdateForm,
	form,
	setForm,
}) => {
	const { value: vendors } = useAsync(getContacts);
	const { setOpen: openContactModal } = useModal('viewContact');
	const { setOpen: openVendorAddModal } = useModal('addVendorModal');
	return (
		<>
			<div className="flex items-center justify-between">
				<SelectContacts
					className="flex-1"
					placeholder="Select a vendor..."
					onChange={(v) => {
						setUpdateForm({
							...updatedForm,
							vendors: [...(updatedForm?.vendors || []), v],
						});
					}}
					skip={updatedForm?.vendors?.map((vendor) => vendor?.id)}
				/>
				<div>
					<PlusCircleIcon
						className="px-2 py-2 w-10 h-10 text-gray-700 cursor-pointer"
						onClick={() =>
							openVendorAddModal({
								onSubmit: (addedVendor) => {
									setUpdateForm({
										...updatedForm,
										vendors: [
											...(updatedForm?.vendors || []),
											addedVendor?.response,
										],
									});
								},
							})
						}
					/>
				</div>
			</div>

			<ul role="list" className="space-y-2">
				{updatedForm?.vendors?.map((person) => (
					<li
						key={person.email}
						className="flex justify-between gap-x-6 py-3 border-gray-200 border-l-8 pl-6 border"
					>
						<div
							className="flex min-w-0 gap-x-2 cursor-pointer w-full"
							onClick={() =>
								openContactModal({ id: person?.id, disableFullProfile: true })
							}
						>
							<AvatarGenerated
								type={person.type}
								id={
									person?.type === 'person'
										? getUserFullName(person)
										: person?.id
								}
								size="xs"
							/>
							<div className="min-w-0 flex-auto">
								<p className="text-sm/6 font-semibold text-gray-900">
									{person.companyName || getUserFullName(person)}{' '}
									<span className="text-gray-600 font-normal">
										{' '}
										{getTitle(person)}
									</span>
								</p>
								<p className="truncate text-xs/5 text-gray-500">
									{person.email}
								</p>
							</div>
						</div>
						<div className="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
							<p className="text-sm/6 text-gray-900">
								<XMarkIcon
									className="w-10 h-10 px-3 py-2 text-gray-600 mr-2 cursor-pointer"
									onClick={() => {
										setUpdateForm({
											...updatedForm,
											vendors: updatedForm?.vendors?.filter(
												(v) => v.id !== person.id
											),
										});
									}}
								/>
							</p>
						</div>
					</li>
				))}
			</ul>
		</>
	);
};

export default VendorsStepAsset;
